import { Grid, Button } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import FilterTable from "../../components/table/FilterTable";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import { USER_ROLES } from "../../helpers/constants";
import { useAccessControl } from "../../hooks/auth/useCheckPermission";
import usePaginationWithSearchParams from "../../hooks/usePaginationWithSearchParams";
import TableService from "../../services/tableService";

import { useTableFieldsConfig, TABLE_NAME } from "./PageTableFieldsConfig";
import { useCustomersSymfoniaCode } from "../../services/customersService";

import InvoicingNavigationBar from "../InvoicingInvestmentBillPage/InvoicingNavigrationBar";

export default function InvoicingSymfoniaCodesPage(props) {
    const { hasAccess } = useAccessControl([USER_ROLES.INVESTMENT_DPI, USER_ROLES.ADMIN, USER_ROLES.ACCOUNT]);

    if (!hasAccess){
        return null
    }

    const { t } = useTranslation();
    const TABLE_FIELDS_CONFIG = useTableFieldsConfig();

    const [dataLocal, setDataLocal] = useState([]);
    const [hiddenColumnsForTables, setHiddenColumnsForTables] = useState([]);
    const [columnsOrdersForTables, setColumnsOrdersForTables] = useState([]);
    const [recordsCount, setRecordsCount] = useState(0);

    const {
        resetPageNumber,
        searchParams,
        setSearchParams,
        page: dataPage,
        pageSize: dataPageSize,
        handleChangePageWithSearchParams: handleChangeDataPage,
        handleChangePageSizeWithSearchParams: handleChangeDataPageSize,
    } = usePaginationWithSearchParams();

    const customerSearchParams = useMemo(() => {
        const params = new URLSearchParams(searchParams);
        params.set("has_agreements", true);
        return params;
    }, [searchParams]);

    const { data: localData, isLoading } = useCustomersSymfoniaCode(customerSearchParams);

    useEffect(() => {
        if (localData?.results) {
            setDataLocal(localData.results);
            setRecordsCount(localData.count);
        }
    }, [localData, dataPage, dataPageSize]);

    const onClickButton = useCallback((e, id) => {
        e.stopPropagation();
    }, []);

    const localDataExportHeaders = useMemo(() => {
        return TableService.getTableExportHeaders(
            TABLE_FIELDS_CONFIG, // @ts-ignore
            hiddenColumnsForTables?.[TABLE_NAME] || [], // @ts-ignore
            columnsOrdersForTables?.[TABLE_NAME] || [],
        );
    }, [TABLE_FIELDS_CONFIG, hiddenColumnsForTables, columnsOrdersForTables]);

    const data = useMemo(
        () =>
            TableService.getPreparedDataForCollapsibleTable(
                TABLE_FIELDS_CONFIG,
                dataLocal, // @ts-ignore
                hiddenColumnsForTables?.[TABLE_NAME]
                    ? // @ts-ignore
                      hiddenColumnsForTables?.[TABLE_NAME]
                    : [], // @ts-ignore
                columnsOrdersForTables?.[TABLE_NAME]
                    ? // @ts-ignore
                      columnsOrdersForTables?.[TABLE_NAME]
                    : [],
                onClickButton,
            ),
        [
            TABLE_FIELDS_CONFIG,
            dataLocal,
            hiddenColumnsForTables,
            columnsOrdersForTables,
            onClickButton,
        ],
    );

    const tableComponent = () => (
        <FilterTable
            // @ts-ignore
            data={data}
            countRecords={recordsCount}
            resetPageNumber={resetPageNumber}
            style={{ maxHeight: "60vh" }}
            headersConfig={TableService.orderColumns(
                TableService.hideHiddenColumns(
                    TABLE_FIELDS_CONFIG, // @ts-ignore
                    hiddenColumnsForTables?.[TABLE_NAME] || [],
                ),
                // @ts-ignore
                columnsOrdersForTables?.[TABLE_NAME] || [],
            )}
            showCleanFilterIcon={true}
            showContextMenu={false}
            showExportToFileButton={true}
            exportToFileUrl={"customers/symfonia_code/export/"}
            exportToFileSearchParams={customerSearchParams}
            exportToFileHeaders={localDataExportHeaders}
            exportToFileFileName={`${t("bankings.exportCustomerSymfoniaCodeFileName")}.xlsx`}
            showDetailsIcon={false}
            showCheckbox={false}
            page={dataPage}
            onPageChange={handleChangeDataPage}
            rowsPerPage={dataPageSize}
            onRowsPerPageChange={handleChangeDataPageSize}
            setDataLocal={setDataLocal}
            isLoading={isLoading}
        />
    );

    return (
        // @ts-ignore
        <DefaultPageWrapper tagTitle={t("headers.invoicing_symfonia_codes")}>
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                rowSpacing={1}
            >
                <Grid item xs={12}>
                    < InvoicingNavigationBar />
                </Grid>
                <Grid item xs={12}>
                    <LoaderWrapper showLoader={false}>{tableComponent()}</LoaderWrapper>
                </Grid>
            </Grid>
        </DefaultPageWrapper>
    );
}
